import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppVersion } from '@ionic-native/app-version';

@Injectable()
export class HelperProvider {

  currentPage: any;

  constructor(public http: HttpClient, private appVersion: AppVersion) {
    this.currentPage = null;
  }

  getFullDate(option?: number){
    let date = new Date();
    let year = date.getUTCFullYear();
    let month = this.addZero(date.getUTCMonth() + 1);
    let day = this.addZero(date.getUTCDate());
    let h = this.addZero(date.getUTCHours());
    let mm = this.addZero(date.getUTCMinutes());
    let ss = this.addZero(date.getUTCSeconds());
    let endDate = ""

    switch(option){
      case 1:
          endDate = year+'-'+month+'-'+day+'-'+h+'-'+mm+'-'+ss;
      break;
      case 2:
          endDate = year+'-'+month+'-'+day+'T'+h+':'+mm+':'+ss+'Z';
      break;
      case 3:
          endDate = day+'-'+month+'-'+year+' '+h+':'+mm+':'+ss;
      break;
      default:
          endDate = year+'-'+month+'-'+day+'T'+h+':'+mm+':'+ss+'Z';
    }  

    return endDate;
  }

  getLocalDate(date: Date, option?: number){
    
    let year = date.getFullYear();
    let month = this.addZero(date.getMonth() + 1);
    let day = this.addZero(date.getDate());
    let h = this.addZero(date.getHours());
    let mm = this.addZero(date.getMinutes());
    let ss = this.addZero(date.getSeconds());
    let endDate = ""

    switch(option){
      case 1:
          endDate = year+'-'+month+'-'+day+'-'+h+'-'+mm+'-'+ss;
      break;
      case 2:
          endDate = year+'-'+month+'-'+day+'T'+h+':'+mm+':'+ss+'Z';
      break;
      case 3:
          endDate = day+'-'+month+'-'+year+' '+h+':'+mm+':'+ss;
      break;
      default:
          endDate = year+'-'+month+'-'+day+'T'+h+':'+mm+':'+ss+'Z';
    }  

    return endDate;
  }

  addZero(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  getAppVersion(){
    return this.appVersion.getVersionNumber();
  }

  getHoursBetweenDates(date1, date2){
    var hours = Math.abs(date1 - date2) / 36e5;
    return Math.trunc(hours);
  }

  getDaysBetweenDates(date){
    let startDate = new Date(date);
    let endDate = new Date(this.getFullDate(2));
    var onedaySecond = 1000 * 3600 * 24;
    var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
    var diffDays = Math.floor(timeDiff / onedaySecond);
    return diffDays;
  }

  getActivePage(){
    return this.currentPage;
  }

  setActivePage(activePage){
    this.currentPage = activePage;
  }

  promiseTimeout(ms, promise) {
    //Create a promise that rejects in <ms> milliseconds
    let timeout = new Promise((resolve, reject) => {
      let id = setTimeout(() => {
        clearTimeout(id);
        reject('Timed out in ' + ms + 'ms.');
      }, ms);
    });

    //Returns a race between timeout and the passed in promise
    return Promise.race([
      promise,
      timeout
    ]);
  }

  /**
   * VP - 27/01/2021
   * Create our own function to detect iOS because Ionic v3 platform detection is not working with iPadOS
   * See https://github.com/ionic-team/ionic-v3/issues/1104
   * 
   * @param win window object
   */
  isIpad = (win: Window = window) => {
    // iOS 12 and below
    if (this.testUserAgent(win, /iPad/i)) {
      return true;
    }
  
    // iOS 13+
    if (this.testUserAgent(win, /Macintosh/i) && this.isMobile(win)) {
      return true;
    }
  
    return false;
  };
  
  isIOS = (win: Window = window) =>
    this.testUserAgent(win, /iPhone|iPod/i) || this.isIpad(win);

  isMobile = (win: Window = window) =>
    this.matchMedia(win, '(any-pointer:coarse)');

  private matchMedia(win: Window, query: string): boolean {
    return win.matchMedia(query).matches;
  }

  private testUserAgent(win: Window, expr: RegExp) {
    return expr.test(win.navigator.userAgent);
  }
}



// WEBPACK FOOTER //
// ./src/providers/helper/helper.ts